<script>
import { required, minValue, integer } from 'vuelidate/lib/validators';
import Repositories from '@/repositories';
const ItemsRepository = Repositories.get('items');
import 'vue-loading-overlay/dist/vue-loading.css';
import Loading from 'vue-loading-overlay';
import scrollMixin from '@/mixins/scrollWheelMixin';
import Tooltip from '@/components/widgets/errors/validations-tooltip.vue';
import Multiselect from 'vue-multiselect';

export default {
  components: {
    Loading,
    Tooltip,
    Multiselect,
  },
  data() {
    return {
      isLoading: false,
      currentMinOrderQuantity: 1,
      itemsList: [],
      editedQuantity: 0,
      isEditedQuantity: false,
      realQuantityError: false,
      form: {
        item: null,
        quantity: 0,
      },
    };
  },
  mixins: [scrollMixin],
  created() {
    this.loadData();
  },
  methods: {
    loadData() {
      this.isLoading = true;
      ItemsRepository.getAll()
        .then((response) => {
          this.itemsList = response.data.data;
          this.isLoading = false;
        })
        .catch(() => {
          this.$toast.errorToast(this.$t('errors.errorLoading'));
          this.isLoading = false;
        });
    },
    setEditedQuantity(currentEditedQuantity) {
      this.editedQuantity = currentEditedQuantity;
      if (this.form.item.quantityType == 'unitary') {
        this.editedQuantity = Number(this.editedQuantity).toFixed(0);
      }
      this.isEditedQuantity = true;
    },
    removeEditedQuantity() {
      this.editedQuantity = 0;
      this.isEditedQuantity = false;
    },
    wheelEditQuantity(event) {
      if (this.form.item != null) {
        this.form.quantity = this.scrollMixinEvent(event, this.form.quantity);
      }
    },
    submitForm() {
      this.$v.form.$touch();
      if (!this.$v.form.$invalid) {
        let quantity = this.form.quantity;

        if (this.form.item.quantityType == 'unitary') {
          quantity = Number(quantity).toFixed(0);
        }

        if (quantity > 0) {
          let payload = {
            item: this.form.item,
            quantity,
          };

          this.$emit('item-to-add', payload);

          this.form.item = null;
          this.form.quantity = 0;
          this.isEditedQuantity = false;
          this.editedQuantity = 0;

          this.$v.$reset();
          this.realQuantityError = false;
        } else {
          this.realQuantityError = true;
        }
      }
    },
    itemSelectionChanged() {
      this.$nextTick(() => this.$refs.addorderquantity.focus());
    },
  },
  validations() {
    return {
      form: this.rules,
    };
  },
  computed: {
    rules() {
      if (this.form.item != null && this.form.item.quantityType == 'unitary') {
        return {
          item: { required },
          quantity: {
            required,
            minValue: minValue(this.currentMinOrderQuantity),
            integer,
          },
        };
      } else {
        return {
          item: { required },
          quantity: {
            required,
            minValue: minValue(this.currentMinOrderQuantity),
          },
        };
      }
    },
    filteredItemsList() {
      return this.itemsList.map((x) => {
        return { ...x, codeandname: x.code + ' - ' + x.name };
      });
    },
    itemRealQuantity() {
      let realOrderQuantity = Number(this.form.quantity);
      if (this.form.item != null) {
        if (realOrderQuantity < this.form.item.minOrderQuantity) {
          realOrderQuantity = Number(this.form.item.minOrderQuantity);
        }

        if (
          this.form.item.lotQuantity > 1 &&
          realOrderQuantity % this.form.item.lotQuantity
        ) {
          realOrderQuantity +=
            Number(this.form.item.lotQuantity) -
            (realOrderQuantity % this.form.item.lotQuantity);
        }
      }

      return realOrderQuantity;
    },
    formQuantityForWatch() {
      return this.form.quantity;
    },
  },
  watch: {
    formQuantityForWatch() {
      this.removeEditedQuantity();
    },
  },
};
</script>

<template>
  <div>
    <loading
      :active.sync="isLoading"
      :can-cancel="false"
      color="#f1b44c"
      :width="70"
      :height="70"
      loader="dots"
      :is-full-page="false"
    >
    </loading>

    <div class="d-flex">
      <b-form-group
        style="margin-bottom: 0"
        class="pr-3 flex-grow-1"
        :label="$t('items.item')"
      >
        <multiselect
          :validator="$v.form.item"
          :class="{
            'is-invalid': $v.form.item.$error,
          }"
          v-model="form.item"
          @input="itemSelectionChanged"
          :options="filteredItemsList"
          :show-labels="false"
          :show-arrow="true"
          :label="'codeandname'"
          track-by="idPublic"
          :placeholder="$t('general.pickAValue')"
          ><template v-slot:noOptions>
            {{ $t('general.noResult') }}
          </template></multiselect
        >
        <Tooltip :validations="$v.form.item" />
      </b-form-group>

      <b-form-group
        style="margin-bottom: 0"
        class="pr-3 quantity-group"
        :label="$t('items.quantity')"
      >
        <b-form-input
          :class="{
            'is-invalid': $v.form.quantity.$error,
          }"
          :disabled="form.item == null"
          type="number"
          ref="addorderquantity"
          :step="
            form.item != null && form.item.quantityType == 'unitary'
              ? '1'
              : '.00001'
          "
          v-model="form.quantity"
          :placeholder="$t('items.quantity')"
          @keydown.enter.prevent="submitForm"
          @wheel.prevent="wheelEditQuantity($event)"
        >
        </b-form-input>

        <Tooltip :validations="$v.form.quantity" />
      </b-form-group>

      <b-form-group style="margin-bottom: 0" class="align-bottom mt-auto">
        <b-button
          @click="submitForm"
          block
          style="height: 40px; margin-top: 27.5px"
          variant="primary"
          >{{ $t('general.add') }}
        </b-button>
      </b-form-group>
    </div>
  </div>
</template>

<style scoped>
.quantity-group {
  min-width: 125px;
  max-width: 125px;
}
</style>
